module.exports = __webpack_public_path__ + "static/media/logo.42784c3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 8
// module chunks = 0